export const formatConversionDownload = [
  {
    id:1,
    name:'convert_rho.x',
    summary:'将OUT.VR、OUT.RHO转换为RHO.XSF格式',
    course:'convert_rho.pdf',
    download:'convert_rho.zip',
  },
  {
    id:2,
    name:'vwr2upf.x',
    summary:'将vwr赝势转换为UPF赝势',
    course:'vwr2upf.pdf',
    download:'vwr2upf.zip',
  },
   {
    id:3,
    name:'uspp2upf.x',
    summary:'将uspp赝势转换为UPF赝势',
    course:'uspp2upf.pdf',
    download:'uspp2upf.zip',
  },
  {
    id:4,
    name:'poscar2config.x',
    summary:'用于将POSCAR文件转换为atom.config',
    course:'poscar2config.pdf',
    download:'poscar2config.zip',
  },
  {
    id:5,
    name:'cell2config.x',
    summary:'用于将CASTEP的CELL文件转换为atom.config',
    course:'cell2config.pdf',
    download:'cell2config.zip',
  },
  {
    id:6,
    name:'xsf2config.x',
    summary:'用于将XSF文件转换为atom.config',
    course:'xsf2config.pdf',
    download:'xsf2config.zip',
  },
  {
    id:7,
    name:'pwscf2config.x',
    summary:'用于将pwscf输入文件转换为atom.config',
    course:'pwscf2config.pdf',
    download:'pwscf2config.zip',
  },
  {
    id:8,
    name:'convert_from_config.x',
    summary:'用于将atom.config转换为xsf和xyz格式的文件',
    course:'convert_from_config.pdf',
    download:'convert_from_config.zip',
  },
  {
    id:9,
    name:'config2poscar.x',
    summary:'用于将atom.config转换为POSCAR格式的文件',
    course:'config2poscar.pdf',
    download:'config2poscar.zip',
  },
  {
    id:10,
    name:'upf2upfSO.x',
    summary:'用于将pwscf的含有spin-orbital的赝势转换为PWmat专有数据格式的赝势',
    course:'upf2upfSO.pdf',
    download:'upf2upfSO.zip',
  },
  {
    id:11,
    name:'atominfo.x',
    summary:'用于给出atom.config中的结构信息',
    course:'atominfo.pdf',
    download:'atominfo.zip',
  }
]


export const dataVisualizationDownload = [
  {
    id:1,
    name:'plot_band.x',
    summary:'用于画能带',
    course:'plot_band_structure.pdf',
    download:'plot_band_structure.zip',
  },
  {
    id:2,
    name:'plot_DOS.py',
    summary:'用于画态密度',
    course:'plot_DOS.pdf',
    download:'plot_DOS.py',
  },
  {
    id:3,
    name:'absorption_spec_R.x',
    summary:'用于RT-TDDFT光谱画图（R-space）',
    course:'absorption_spec_R.pdf',
    download:'absorption_spec.zip',
  },
  {
    id:4,
    name:'absorption_spec_K.x',
    summary:'用于RT-TDDFT光谱画图（K-space）',
    course:'absorption_spec_K.pdf',
    download:'absorption_spec.zip',
  },
  {
    id:5,
    name:'plot_wg.x',
    summary:'用于画波函数（OUT.WG）',
    course:'plot_wg.pdf',
    download:'plot_wg.zip',
  },
  {
    id:6,
    name:'plot_DOS_interp.x',
    summary:'用于输出加密K点的DOS图',
    course:'plot_DOS_interp.pdf',
    download:'plot_DOS_interp.zip',
  },
  {
    id:7,
    name:'plot_ABSORB_interp.x',
    summary:'用于画基态吸收谱',
    course:'plot_ABSORB_interp.pdf',
    download:'plot_ABSORB_interp.zip',
  },
  {
    id:8,
    name:'plot_TDDFT.x',
    summary:'用于画RT-TDDFT的输出图像',
    course:'plot_TDDFT.pdf',
    download:'plot_TDDFT.zip',
  },
]

export const dataPostProcessingDownload = [
  {
    id:1,
    name:'add_field.x',
    summary:'用于产生外加电场',
    course:'add_field.pdf',
    download:'add_field.zip',
  },
  {
    id:2,
    name:'split_kp.x',
    summary:'用于切割高对称K点文件',
    course:'split_kp.pdf',
    download:'split_kp.zip',
  },
  {
    id:3,
    name:'NAMD_psi.x',
    summary:'用于查看NAMD计算中的波函数',
    course:'NAMD_psi.pdf',
    download:'NAMD_psi.zip',
  },
  {
    id:4,
    name:'NAMD_Boltzman.x',
    summary:'用于计算NAMD中的boltzman常数',
    course:'NAMD_Boltzman.pdf',
    download:'NAMD_Boltzman.zip',
  },
  {
    id:5,
    name:'ug_moment.x',
    summary:'用于光学性质计算的角动量',
    course:'ug_moment.pdf',
    download:'ug_moment.zip',
  },
  {
    id:6,
    name:'vacuum.x',
    summary:'用于计算真空层能级',
    course:'vacuumt.pdf',
    download:'vacuum.zip',
  },
]